import type { LucideIcon } from 'lucide-react';
import type { Tone } from '@shared/config/theme';
import { toneChipClasses } from '@shared/utils/statusTone';

interface StatusChipProps {
  tone: Tone;
  label: string;
  icon?: LucideIcon;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * State indicator: always icon + label, never color alone (WCAG SC 1.4.1).
 * Replaces the ~20 inline ternary chains that duplicated state colors.
 */
export function StatusChip({
  tone,
  label,
  icon: Icon,
  size = 'sm',
  className = '',
}: StatusChipProps) {
  const sizing = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  const iconSize = size === 'sm' ? 12 : 14;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${sizing} ${toneChipClasses[tone]} ${className}`}
    >
      {Icon ? (
        <Icon size={iconSize} aria-hidden="true" />
      ) : (
        <i className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true" />
      )}
      {label}
    </span>
  );
}

export default StatusChip;
